/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unmuteActor.defs'
export { main as default } from './unmuteActor.defs'
